<app-accordion title="Emulate" [adminOnly]="true">
  <div>
    <div class="flex column gap-1 admin-content">
      @if (!globalService.emulatedUser()) {
        <div class="flex col align-center gap-05">
          <div class="flex align-center gap-05">
            <input
              type="text"
              pInputText
              placeholder="Emulate Employee"
              [(ngModel)]="emulatedUser"
              [maxlength]="6"
            />
            <app-button
              label="Emulate"
              [outlined]="true"
              [disabled]="!emulatedUser || emulatedUser.length < 6"
              (click)="handleEmulate()"
            />
            <!-- <p-button label="Emulate" [outlined]="true"></p-button> -->
          </div>
          @if (recentEmulates.length > 0) {
            <div
              class="width-100 padding-05-l"
              style="color: var(--text-label)"
            >
              History
            </div>
            <div class="bordered-content col width-100">
              <div class="label-value">
                <div class="label">Employee</div>
                <div class="label">Date</div>
                <div class="label">Emulate</div>
              </div>
              @for (recentEmulatedUser of recentEmulates; track $index) {
                <div class="label-value padding-05-t">
                  <div class="value multi">
                    {{ recentEmulatedUser.employee }}
                  </div>
                  <div class="value multi">{{ recentEmulatedUser.date }}</div>
                  <div
                    class="clickable"
                    (click)="handleReEmulate(recentEmulatedUser.employee)"
                  >
                    View
                  </div>
                </div>
              }
            </div>
            <div
              class="width-100 padding-05-l padding-05-r"
              style="color: var(--text-color-secondary)"
            >
              This list is limited to the last 10 emulated employees and is
              device specific.
            </div>
          } @else {
            <div
              class="width-100 padding-05-l padding-05-r"
              style="color: var(--text-color-secondary)"
            >
              Recently emulated employees will show up here. The list is device
              specific.
            </div>
          }
        </div>
      } @else {
        @if (emulatedUserProfile$ | async; as emulatedUserProfile) {
          <div class="bordered-content">
            <div class="label-value col">
              @if (!emulatedUserProfile.response?.firstName) {
                <p-skeleton width="9rem" height="1rem" />
              } @else {
                <div class="value">
                  {{ emulatedUserProfile.response?.firstName | lowerCase }}
                  {{ emulatedUserProfile.response?.lastName | lowerCase }}
                </div>
              }
              <div>Name</div>
            </div>
          </div>
          <div class="bordered-content">
            @for (detail of companyDetails; track $index) {
              <div class="label-value col">
                @if (
                  emulatedUserProfile.isLoading || !emulatedUserProfile.response
                ) {
                  <p-skeleton width="3rem" height="1rem" />
                } @else {
                  <div class="value">
                    {{ getValue(detail.key, emulatedUserProfile.response) }}
                  </div>
                }
                <div>{{ detail.label }}</div>
              </div>
            }
          </div>
          <div class="bordered-content">
            @for (detail of statusDetails; track $index) {
              <div class="label-value col">
                @if (
                  emulatedUserProfile.isLoading || !emulatedUserProfile.response
                ) {
                  <p-skeleton width="3rem" height="1rem" />
                } @else {
                  <div class="value">
                    {{ getValue(detail.key, emulatedUserProfile.response) }}
                  </div>
                }
                <div>{{ detail.label }}</div>
              </div>
            }
          </div>
          <div class="bordered-content col">
            @if (!contactShown) {
              <app-button
                label="Show contact info"
                [outlined]="true"
                [text]="true"
                (click)="getMemberInfo()"
              />
            } @else {
              @if (memberInfo$ | async; as memberInfo) {
                @if (memberInfo.isLoading) {
                  <div class="flex align-center flex-center gap-05 width-100">
                    <p-progressSpinner
                      class="flex flex-center"
                      [style]="{ width: '2rem', height: '2rem' }"
                      strokeWidth="6"
                      animationDuration=".5s"
                    />
                    <div>Loading...</div>
                  </div>
                } @else if (memberInfo.response) {
                  @if (memberInfo.response.telephone.length > 1) {
                    <div class="label-value">
                      <div>Phone</div>
                      <div class="value">
                        {{ memberInfo.response.telephone }}
                      </div>
                    </div>
                  }
                  @if (memberInfo.response.cell.length > 1) {
                    <div class="label-value">
                      <div>Cell</div>
                      <div class="value">{{ memberInfo.response.cell }}</div>
                    </div>
                  }
                  @if (memberInfo.response.primaryEmail.length > 1) {
                    <div class="label-value">
                      <div>Email</div>
                      <div class="value">
                        {{ memberInfo.response.primaryEmail }}
                      </div>
                    </div>
                  }
                }
              }
            }
          </div>
          <app-button
            label="Stop Emulation"
            severity="danger"
            class="width-100"
            [outlined]="true"
            [text]="true"
            (click)="handleStopEmulate()"
          />
        }
      }
    </div>
  </div>
</app-accordion>
